import moment from "moment";
import momentTz from "moment-timezone";

const locale = momentTz.tz.guess();

export const dateFormat = "YYYY-MM-DD HH:mm:ss";

export const getLocalTime = (dateUTC: string): moment.Moment => moment.utc(dateUTC).tz(locale);
